module.exports = __webpack_public_path__ + "static/media/centri-cat2.58cf8dba.png";